var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78874 4.79169H6.4554C5.57135 4.79169 4.7235 5.14288 4.09838 5.768C3.47326 6.39312 3.12207 7.24097 3.12207 8.12502V8.95835",
    stroke: "#676777",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70508 2.70831L9.78841 4.79165L7.70508 6.87498",
    stroke: "#676777",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4551 9.79169H9.78841C9.5674 9.79169 9.35544 9.87948 9.19916 10.0358C9.04287 10.192 8.95508 10.404 8.95508 10.625V17.2917",
    stroke: "#676777",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28809 15.625H13.9548C14.1758 15.625 14.3877 15.5372 14.544 15.3809C14.7003 15.2246 14.7881 15.0127 14.7881 14.7917V8.125",
    stroke: "#676777",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateFrame);
export default __webpack_public_path__ + "static/media/rotate-frame.a3d2fa208883687bfe2f5c352aa1e697.svg";
export { ForwardRef as ReactComponent };